var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d8ca53513b7dcd23c6f1aa20a84f6ec31ee72ea6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"d8ca53513b7dcd23c6f1aa20a84f6ec31ee72ea6"};
      